import React, { useState, useEffect, useContext } from "react";
import { BlackAndWhite } from "../../themes/Colors";
import useWindowDimensions from "../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  SectionTitle,
  TextAreaInput,
  TextInputField,
  TextInputFieldSearch,
} from "../../components/atoms";
import { AdminContext } from "../../context/admin-context";
import { useNavigate } from "react-router-dom";
import AdminCustomerTab from "../admin-portal/components/AdminCustomerTab";
import QuestionButton from "../customer-portal/components/medical-history/components/button/QuestionButton";
import {
  CannaMenuButton,
  CashRegister,
  DashBoardPos,
  InventoryPos,
  KnowledgeBasePanel,
  PatientDisplay,
  ProcessSale,
  ProfileMenu,
  RegisterPanel,
  SalesHistory,
  SupportDisplay,
} from "./components";
import PopUp from "./components/pop-up/PopUp";
import { LoadingPopUp, ToastNotification } from "../../components";
import PatientProfilePopUp from "./components/patient-display/PatientProfilePopUp";
import { HeadersPatients } from "./components/patient-display/components";
import SearchBar from "./components/patient-display/SearchBar";
import { ProductKnowledgeDisplayModal } from "./components/knowledge-base-panel/components";
import TabCategoryOptions from "../admin-portal/components/product-uploader/components/tab-category-options/TabCategoryOptions";

// import { useNavigate } from "react-router-dom";

const CannaPosAccess = () => {
  const [patientProfilePop, setPatientProfilePop] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const { width, height } = useWindowDimensions();
  const [passwordPop, setPasswordPop] = useState(true);
  const [tab, setTab] = useState("dashboard");
  const [toastPop, setToastPop] = useState(false);
  const [message, setMessage] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [storeInfo, setStoreInfo] = useState(null);

  const [refreshHover, setRefreshHover] = useState(false);

  const [loading, setLoading] = useState(false);

  const [shrink, setShrink] = useState(false);

  const [onMenu, setOnMenu] = useState(false);

  const [searchBy, setSearchBy] = useState("ID NUMBER");

  const [cashRegisterReset, setCashRegisterReset] = useState(false);

  //add product info
  // const [urlPath, setUrlPath] = useState("");
  const admin = useContext(AdminContext);
  const navigate = useNavigate();

  const [selectedProductDisplay, setSelectedProductDisplay] = useState(null);

  const [search, setSearch] = useState("");

  const [customers, setCustomers] = useState(null);

  const [cashRegisterOpen, setCashRegisterOpen] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);

  const LogOut = () => {
    admin.logout();

    navigate("/adminPortal");
  };

  const OnUserSearch = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/user/searchForUserPos",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchParameter: search,
            userId: admin.adminUserData.userId,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        setLoading(false);
        setCustomers(responseData.data);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };
  const GetStoreInfo = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/processSale/fetchStoreInfo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            storeName: admin.adminUserData.storeName,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        setStoreInfo(responseData.store);
      }
    } catch (err) {
      console.log("error", err);
    }
  };
  const [cashRegisterOpenCheck, setCashRegisterOpenCheck] = useState(null);

  const CheckIfCashREgosterIsOpen = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/cashRegister/checkIfRegisterOpen",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // storeName: user.adminUserData.storeName,
            storeId: storeInfo.storeId,
            userId: admin.adminUserData.userId,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        setCashRegisterOpenCheck(responseData.storeCahsRegisterHistory);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (storeInfo) {
      CheckIfCashREgosterIsOpen();
    }
  }, [tab, storeInfo]);
  useEffect(() => {
    if (storeInfo) {
      CheckIfCashREgosterIsOpen();
    }
  }, [cashRegisterReset]);
  useEffect(() => {
    if (!admin.isloggedIn || admin.adminUserData.type === "Doc") {
      navigate("/adminPortal");
    } else if (!admin.isloggedIn || admin.adminUserData.type === "Customer") {
      navigate("/");
    } else if (!admin.isloggedIn || admin.adminUserData.type === "Support") {
      navigate("/adminPortal");
    }
  }, []);
  useEffect(() => {
    GetStoreInfo();
  }, []);
  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);
      }, 5000);
    }
  }, [toastPop]);
  return (
    <div
      style={{
        height: height,
        width: width,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: BlackAndWhite.red,
        position: "relative",
      }}
    >
      <div
        style={{
          fontSize: 30,
          fontWeight: "700",
          color: BlackAndWhite.secondary,
          position: "fixed",
          width: "100%",
          backgroundColor: BlackAndWhite.primary,
          top: 0,
          height: 60,
          display: "flex",
          alignItems: "center",
          zIndex: 2000,
          WebkitBoxShadow: "0px 0px 10px 1px #00000033",
          // borderBottomStyle: "solid",
          // borderBottomWidth: 6,
          // borderBottomColor: BlackAndWhite.red,
        }}
      >
        <div
          // onClick={() => setShrink(shrink ? false : true)}
          style={{
            // marginLeft: shrink ? 15 : 5,
            backgroundColor: shrink ? "#FFFFFFcc" : BlackAndWhite.secondary,
            height: 60,
            width: 60,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: shrink ? 200 : 20,
            position: "absolute",
            top: shrink ? 10 : 0,
            // WebkitBoxShadow: "0px 0px 10px 1px #00000033",
            transition: "all 0.3s",
            // borderStyle: "solid",
            // borderColor: BlackAndWhite.primary,
            // borderWidth: 5,
          }}
        >
          <div
            // onClick={() => setShrink(shrink ? false : true)}
            style={{
              // marginLeft: shrink ? 5 : 5,
              backgroundColor: shrink
                ? BlackAndWhite.primary
                : BlackAndWhite.secondary,
              height: 60,
              minWidth: 60,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // borderRadius: shrink ? 200 : 8,
              // position: "absolute",
              // top: shrink ? 10 : 5,
              // WebkitBoxShadow: "0px 0px 10px 1px #00000033",
              transition: "all 0.3s",
              // borderStyle: "solid",
              // borderColor: BlackAndWhite.primary,
              // borderWidth: 5,
              overflow: "hidden",
            }}
          >
            <img
              alt="load"
              src={require("../../images/rooftopLogo/RoofTopLogo512.png")}
              style={{
                height: 60,
                transition: "all 0.3s",
              }}
            />
          </div>
        </div>
        <div
          style={{
            // flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          {/* <div
            style={{
              fontSize: 16,
              marginLeft: 80,
              fontWeight: "bolder",
              transition: "all 0.3s",
            }}
          >
            {tab
              ? tab === "Knowledge Base"
                ? "PRODUCT INFO"
                : tab.toLocaleUpperCase()
              : "loading"}
          </div> */}
          <div style={{ marginLeft: 75 }}>
            <img
              onMouseOver={() => setRefreshHover(true)}
              onMouseOut={() => setRefreshHover(false)}
              onClick={() => setRefresh(refresh ? false : true)}
              alt="icon"
              src={require("../../images/material-icons/refreshwhite.png")}
              style={{
                height: refreshHover ? 40 : 40,
                // backgroundColor: BlackAndWhite.primary,
                borderRadius: 50,
                marginTop: 10,
                transform: loading
                  ? `rotate(360deg)`
                  : refreshHover
                  ? `rotate(0deg)`
                  : `rotate(360deg)`,
                transition: loading ? "transform 3s" : "all 0.7s",
              }}
            />
          </div>
        </div>
        {/* menu */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: menuOpen ? "100%" : 240,
            overflowX: "hidden",

            // backgroundColor: "#FFFFFF",
            height: "100%",
            // marginTop: 10,
            alignItems: "flex-start",
            justifyContent: "flex-start",
            transition: "all 0.3s",
            WebkitBoxShadow: "0px 0px 10px 1px #00000033",
            zIndex: 1000,
            left: menuOpen ? 0 : 130,
            position: "absolute",
            // marginLeft: shrink ? 20 : 0,
          }}
        >
          {!menuOpen ? (
            <QuestionButton
              borderOn={tab === "dashboard" ? true : false}
              title={tab.toLocaleUpperCase()}
              height={60}
              onClick={() => setTab("dashboard")}
              backgroundColor={BlackAndWhite.secondary}
              backgroundColorAlt={BlackAndWhite.secondary}
              color={BlackAndWhite.primary}
              colorAlt={BlackAndWhite.primary}
              width={100}
              icon={
                tab === "dashboard"
                  ? require("../../images/material-icons/dashboardBlack.png")
                  : require("../../images/material-icons/dashboardBlack.png")
              }
              // selected={tab === "knowledge" ? true : false}
              icon2={require("../../images/material-icons/dashboardBlack.png")}
              questionAmount={true}
              borderRadius={0}
            />
          ) : null}
          {!menuOpen ? (
            <BaseButtons
              label={"OPEN MENU"}
              width={90}
              size={90}
              backgroundColor={BlackAndWhite.red}
              marginTopFalse={true}
              mini={true}
              height={60}
              minWidth={90}
              fontWeight={"bold"}
              onClick={() => setMenuOpen(true)}
              borderWidth={0}
            />
          ) : null}
          {/* <div style={{ height: shrink ? 110 : 150, transition: "all 0.3s" }} /> */}
        </div>
        <div style={{ flex: 1 }}></div>
        <div
          style={{
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 5,
            paddingBottom: 5,
            borderRadius: 8,
            borderStyle: "solid",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 20,
            borderWidth: 0.5,
          }}
        >
          <div style={{ fontSize: 14 }}>
            Store:{" "}
            {admin.adminUserData ? admin.adminUserData.storeName : "loading"}
          </div>
        </div>
        <div
          style={{
            marginRight: 20,
            fontSize: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ marginRight: 7 }}>
            {admin.adminUserData ? admin.adminUserData.firstName : "loading"}
          </div>
          <div style={{ marginRight: 12 }}>
            {admin.adminUserData ? admin.adminUserData.lastName : "loading"}
          </div>

          <div
            onClick={() => setOnMenu(onMenu ? false : true)}
            style={{
              height: 25,
              width: 25,
              backgroundColor: onMenu
                ? BlackAndWhite.primary
                : BlackAndWhite.secondary,
              // borderRadius: 100,
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              transition: "0.3s",
            }}
          >
            <div
              style={{
                height: 5,
                width: 5,
                borderRadius: 20,
                backgroundColor: onMenu
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary,
                transition: "0.3s",
              }}
            />
            <div
              style={{
                height: 5,
                width: 5,
                borderRadius: 20,
                backgroundColor: onMenu
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary,
                transition: "0.3s",
              }}
            />
            <div
              style={{
                height: 5,
                width: 5,
                borderRadius: 20,
                backgroundColor: onMenu
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary,
                transition: "0.3s",
              }}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          height: "95%",
          width: "100%",

          marginTop: 75,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FFFFFF99",
        }}
      >
        {tab === "CUSTOMERS" ? (
          <div
            style={{
              height: 60,
              width: "100%",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FFFFFF",
            }}
          >
            {/* search section */}
            <div style={{ marginLeft: 2, marginRight: 10, marginBottom: 0 }}>
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  // width: 300,

                  borderWidth: 0.5,
                }}
              >
                <TextInputFieldSearch
                  placeholder={"Type here to search"}
                  height={50}
                  borderRadius={0.1}
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                />
                <div
                  onClick={() => {
                    setSearch("");
                    setCustomers(null);
                  }}
                  style={{
                    height: 56,
                    minWidth: 100,
                    backgroundColor: BlackAndWhite.primary,
                    // borderRadius: 4,
                    display: "flex",
                    color: BlackAndWhite.secondary,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    marginLeft: 1,
                  }}
                >
                  <div style={{ fontSize: 12, fontWeight: "bold" }}>CLEAR</div>
                </div>
                <div
                  onClick={search === "" ? null : () => OnUserSearch()}
                  style={{
                    height: 56,
                    minWidth: 100,
                    backgroundColor: BlackAndWhite.primary,
                    // borderRadius: 4,
                    display: "flex",
                    color: BlackAndWhite.secondary,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: search === "" ? "not-allowed" : "pointer",
                    marginLeft: 2,
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      opacity: search === "" ? 0.5 : 1,
                    }}
                  >
                    SEARCH
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: 1 }}></div>
          </div>
        ) : null}

        {tab === "CUSTOMERS" ? <HeadersPatients /> : null}
        {tab === "CUSTOMERS" ? (
          <PatientDisplay
            setToastPop={setToastPop}
            setMessage={setMessage}
            setPatientProfilePop={setPatientProfilePop}
            setSelectedPatient={setSelectedPatient}
            setLoading={setLoading}
            width={width}
            search={search}
            setRefresh={setRefresh}
            refresh={refresh}
            loading={loading}
            customers={customers}
            setSearch={setSearch}
          />
        ) : null}

        {tab === "dashboard" ? (
          <DashBoardPos
            user={admin}
            refresh={refresh}
            setLoading={setLoading}
            search={search}
            setSearch={setSearch}
            customers={customers}
            OnUserSearch={OnUserSearch}
            setCustomers={setCustomers}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
          />
        ) : null}

        {tab === "Knowledge Base" ? (
          <KnowledgeBasePanel
            setToastPop={setToastPop}
            setMessage={setMessage}
            setLoading={setLoading}
            setSelectedProductDisplay={setSelectedProductDisplay}
            setRefresh={setRefresh}
            refresh={refresh}
          />
        ) : null}
        {tab === "support" ? (
          <SupportDisplay
            user={admin}
            refresh={refresh}
            setLoading={setLoading}
            search={search}
            setSearch={setSearch}
            customers={customers}
            OnUserSearch={OnUserSearch}
            setCustomers={setCustomers}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
          />
        ) : null}

        {tab === "INVENTORY" ? (
          <InventoryPos
            user={admin}
            refresh={refresh}
            setLoading={setLoading}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            storeId={storeInfo.storeId}
          />
        ) : null}
        {tab === "CASH REGISTER" ? (
          <CashRegister
            storeInfo={storeInfo}
            setCashRegisterOpenCheck={setCashRegisterOpenCheck}
            cashRegisterOpenCheck={cashRegisterOpenCheck}
            user={admin}
            refresh={refresh}
            setLoading={setLoading}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            setCashRegisterReset={setCashRegisterReset}
            cashRegisterReset={cashRegisterReset}
          />
        ) : null}
        {tab === "PROCESS SALE" ? (
          <ProcessSale
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            user={admin}
            refresh={refresh}
            setLoading={setLoading}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            storeInfo={storeInfo}
            setStoreInfo={setStoreInfo}
            cashRegisterOpenCheck={cashRegisterOpenCheck}
            setTab={setTab}
          />
        ) : null}
        {tab === "SALES HISTORY" ? (
          <SalesHistory
            user={admin}
            refresh={refresh}
            setLoading={setLoading}
            setToastPop={setToastPop}
            setMessage={setMessage}
            setRefresh={setRefresh}
            storeInfo={storeInfo}
            setStoreInfo={setStoreInfo}
            cashRegisterOpenCheck={cashRegisterOpenCheck}
          />
        ) : null}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: menuOpen ? "100%" : 0,
            overflowX: "hidden",
            width: 200,
            backgroundColor: "#FFFFFF",
            // height: "100%",
            // marginTop: 10,
            alignItems: "flex-start",
            justifyContent: "flex-start",
            // transition: "all 0.3s",
            WebkitBoxShadow: "0px 0px 10px 1px #00000033",
            zIndex: 220000000000,
            left: menuOpen ? 0 : 130,
            position: "absolute",
            // marginLeft: shrink ? 20 : 0,
          }}
        >
          {shrink ? (
            <CannaMenuButton
              // width={"90%"}
              selected={tab === "dashboard" ? true : false}
              iconImage={
                tab === "dashboard"
                  ? require("../../images/material-icons/dashboardWhite.png")
                  : require("../../images/material-icons/dashboardBlack.png")
              }
              onClick={() => setTab("dashboard")}
              height={30}
            />
          ) : (
            <QuestionButton
              borderOn={tab === "dashboard" ? true : false}
              title={"DASHBOARD"}
              height={60}
              onClick={() => {
                setTab("dashboard");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "dashboard"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "dashboard"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "dashboard"
                  ? require("../../images/material-icons/dashboardBlack.png")
                  : require("../../images/material-icons/dashboardWhite.png")
              }
              // selected={tab === "knowledge" ? true : false}
              icon2={require("../../images/material-icons/dashboardBlack.png")}
              questionAmount={true}
              borderRadius={0}
            />
          )}

          {/* <div style={{ height: 5 }} /> */}
          {shrink ? (
            <CannaMenuButton
              // disable={cashRegisterOpen ? false : true}
              // width={"90%"}
              iconImage={
                tab === "CUSTOMERS"
                  ? require("../../images/material-icons/profileWhite.png")
                  : require("../../images/material-icons/profileBlack.png")
              }
              height={35}
              onClick={() => setTab("CUSTOMERS")}
              selected={tab === "CUSTOMERS" ? true : false}
            />
          ) : (
            <QuestionButton
              // disable={cashRegisterOpen ? false : true}
              title={"CUSTOMERS"}
              height={60}
              onClick={() => {
                setTab("CUSTOMERS");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "CUSTOMERS"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "CUSTOMERS"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "CUSTOMERS"
                  ? require("../../images/material-icons/profileBlack.png")
                  : require("../../images/material-icons/profileWhite.png")
              }
              icon2={require("../../images/material-icons/profileBlack.png")}
              questionAmount={true}
              borderOn={tab === "CUSTOMERS" ? true : false}
              // borderRadius={8}
            />
          )}
          {/* <div style={{ height: 5 }} /> */}
          {/* {shrink ? (
            <CannaMenuButton
              // disable={true}
              // width={"90%"}
              disable={
                cashRegisterOpenCheck !== "No Register Found" &&
                cashRegisterOpenCheck !== null
                  ? false
                  : true
              }
              height={35}
              onClick={() => setTab("PROCESS SALE")}
              selected={tab === "PROCESS SALE" ? true : false}
              iconImage={
                tab === "PROCESS SALE"
                  ? require("../../images/material-icons/posWhite.png")
                  : require("../../images/material-icons/posBlack.png")
              }
            />
          ) : (
            <QuestionButton
              // disable={true}
              disable={
                cashRegisterOpenCheck !== "No Register Found" &&
                cashRegisterOpenCheck !== null
                  ? false
                  : true
              }
              borderOn={tab === "PROCESS SALE" ? true : false}
              title={"PROCESS SALE"}
              height={60}
              onClick={() => {
                setTab("PROCESS SALE");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "PROCESS SALE"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "PROCESS SALE"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "PROCESS SALE"
                  ? require("../../images/material-icons/posBlack.png")
                  : require("../../images/material-icons/posWhite.png")
              }
              icon2={require("../../images/material-icons/posBlack.png")}
              // selected={tab === "knowledge" ? true : false}
              questionAmount={true}
              // borderRadius={8}
            />
          )} */}
          {/* <div style={{ height: 5 }} /> */}

          {/* <div style={{ height: 5 }} />
       
          {/* <div style={{ height: 5 }} /> */}
          {shrink ? (
            <CannaMenuButton
              // disable={true}
              // width={"90%"}
              disable={
                cashRegisterOpenCheck !== "No Register Found" &&
                cashRegisterOpenCheck !== null
                  ? false
                  : true
              }
              height={60}
              onClick={() => setTab("SALES HISTORY")}
              selected={tab === "SALES HISTORY" ? true : false}
              iconImage={
                tab === "SALES HISTORY"
                  ? require("../../images/material-icons/reportWhite.png")
                  : require("../../images/material-icons/reportBlack.png")
              }
            />
          ) : (
            <QuestionButton
              // disable={true}
              disable={
                cashRegisterOpenCheck !== "No Register Found" &&
                cashRegisterOpenCheck !== null
                  ? false
                  : true
              }
              borderOn={tab === "SALES HISTORY" ? true : false}
              title={"SALES HISTORY"}
              height={60}
              onClick={() => {
                setTab("SALES HISTORY");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "SALES HISTORY"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "SALES HISTORY"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.secondary}
              width={"100%"}
              icon={
                tab === "SALES HISTORY"
                  ? require("../../images/material-icons/reportBlack.png")
                  : require("../../images/material-icons/reportWhite.png")
              }
              icon2={require("../../images/material-icons/reportBlack.png")}
              // selected={tab === "register" ? true : false}
              questionAmount={true}
              // borderRadius={8}
            />
          )}
          {/* <div style={{ height: 5 }} /> */}
          {shrink ? (
            <CannaMenuButton
              // disable={true}
              // width={"90%"}
              height={35}
              onClick={() => setTab("CASH REGISTER")}
              selected={tab === "CASH REGISTER" ? true : false}
              iconImage={
                tab === "CASH REGISTER"
                  ? require("../../images/material-icons/setupAndMangeWhite.png")
                  : require("../../images/material-icons/setupAndMangeBlack.png")
              }
            />
          ) : (
            <QuestionButton
              // disable={true}
              borderOn={tab === "CASH REGISTER" ? true : false}
              title={"SALES REGISTER"}
              height={60}
              onClick={() => {
                setTab("CASH REGISTER");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "CASH REGISTER"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "CASH REGISTER"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "CASH REGISTER"
                  ? require("../../images/material-icons/setupAndMangeBlack.png")
                  : require("../../images/material-icons/setupAndMangeWhite.png")
              }
              icon2={require("../../images/material-icons/setupAndMangeBlack.png")}
              // selected={tab === "register" ? true : false}
              questionAmount={true}
              // borderRadius={8}
            />
          )}
          {/* <div style={{ height: 5 }} /> */}
          {shrink ? (
            <CannaMenuButton
              // disable={true}
              // width={"90%"}
              // disable={cashRegisterOpen ? false : true}
              height={35}
              onClick={() => setTab("INVENTORY")}
              selected={tab === "INVENTORY" ? true : false}
              iconImage={
                tab === "INVENTORY"
                  ? require("../../images/material-icons/inventoryWhite.png")
                  : require("../../images/material-icons/inventoryBlack.png")
              }
            />
          ) : (
            <QuestionButton
              // disable={true}
              // disable={cashRegisterOpen ? false : true}
              borderOn={tab === "INVENTORY" ? true : false}
              title={"INVENTORY"}
              height={60}
              onClick={() => {
                setTab("INVENTORY");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "INVENTORY"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "INVENTORY"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "INVENTORY"
                  ? require("../../images/material-icons/inventoryBlack.png")
                  : require("../../images/material-icons/inventoryWhite.png")
              }
              icon2={require("../../images/material-icons/inventoryBlack.png")}
              // selected={tab === "register" ? true : false}
              questionAmount={true}
              // borderRadius={8}
            />
          )}
          {/* <div style={{ height: 5 }} /> */}
          {shrink ? (
            <CannaMenuButton
              // width={"90%"}
              height={30}
              onClick={() => setTab("Knowledge Base")}
              selected={tab === "Knowledge Base" ? true : false}
              iconImage={
                tab === "Knowledge Base"
                  ? require("../../images/material-icons/productWhite.png")
                  : require("../../images/material-icons/productBlack.png")
              }
            />
          ) : (
            <QuestionButton
              borderOn={tab === "Knowledge Base" ? true : false}
              title={"PRODUCT INFO"}
              height={60}
              onClick={() => {
                setTab("Knowledge Base");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "Knowledge Base"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "Knowledge Base"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "Knowledge Base"
                  ? require("../../images/material-icons/productBlack.png")
                  : require("../../images/material-icons/productWhite.png")
              }
              // selected={tab === "register" ? true : false}
              questionAmount={true}
              icon2={require("../../images/material-icons/productBlack.png")}
              // borderRadius={8}
            />
          )}
          {/* <div style={{ height: 5 }} /> */}
          {shrink ? (
            <CannaMenuButton
              // width={"90%"}
              height={30}
              onClick={() => setTab("support")}
              selected={tab === "support" ? true : false}
              iconImage={
                tab === "support"
                  ? require("../../images/material-icons/qrCodeBlack.png")
                  : require("../../images/material-icons/qrcodeWhite.png")
              }
            />
          ) : (
            <QuestionButton
              borderOn={tab === "support" ? true : false}
              title={"SUPPORT"}
              height={60}
              onClick={() => {
                setTab("support");
                setMenuOpen(false);
              }}
              backgroundColor={
                tab === "support"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
              }
              backgroundColorAlt={BlackAndWhite.secondary}
              color={
                tab === "support"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
              }
              colorAlt={BlackAndWhite.primary}
              width={"100%"}
              icon={
                tab === "support"
                  ? require("../../images/material-icons/qrCodeBlack.png")
                  : require("../../images/material-icons/qrcodeWhite.png")
              }
              icon2={require("../../images/material-icons/qrCodeBlack.png")}
              // selected={tab === "register" ? true : false}
              questionAmount={true}
              // borderRadius={8}
            />
          )}
        </div>
      </div>
      <ToastNotification display={toastPop} message={message.toUpperCase()} />
      <ProfileMenu
        display={onMenu}
        username={
          admin.adminUserData ? admin.adminUserData.userName : "loading"
        }
        idNum={admin.adminUserData ? admin.adminUserData.idDoc : "loading"}
        store={admin.adminUserData ? admin.adminUserData.storeName : "loading"}
        province={
          admin.adminUserData ? admin.adminUserData.province : "loading"
        }
        onCancelClick={() => setOnMenu(false)}
        onLogOutClick={() => LogOut()}
      />
      <PatientProfilePopUp
        cashRegisterOpenCheck={cashRegisterOpenCheck}
        display={patientProfilePop}
        selectedPatient={selectedPatient}
        onCloseClick={() => {
          setPatientProfilePop(false);
          setSelectedPatient(null);
        }}
        loading={loading}
        setLoading={setLoading}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        setTab={setTab}
        setPatientProfilePop={setPatientProfilePop}
        setSelectedPatient={setSelectedPatient}
      />
      <ProductKnowledgeDisplayModal
        display={selectedProductDisplay}
        onCloseClick={() => setSelectedProductDisplay(null)}
        selectedProductDisplay={selectedProductDisplay}
      />
      <LoadingPopUp display={loading} />
    </div>
  );
};

export default CannaPosAccess;
